import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { ViewTribute as ViewTributeView } from '@modules/Tributes/Views/ViewTribute/ViewTribute';


export const ViewTribute: React.FC = () => {
  const { tributeId } = useParams();
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <ViewTributeView tributeId={tributeId} />
      </Suspense>
    </ErrorBoundary>
  );
};
